import { defineComponent as d, getCurrentInstance as f, onMounted as u, onBeforeUnmount as a, renderSlot as m } from "vue";
import i from "./ghl-ui.es1218.js";
import { warn as o } from "./ghl-ui.es1219.js";
const x = d({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(s) {
    let n = !1;
    const r = f().proxy;
    function l(e) {
      const { onResize: t } = s;
      t !== void 0 && t(e);
    }
    u(() => {
      const e = r.$el;
      if (e === void 0) {
        o("resize-observer", "$el does not exist.");
        return;
      }
      if (e.nextElementSibling !== e.nextSibling && e.nodeType === 3 && e.nodeValue !== "") {
        o("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      e.nextElementSibling !== null && (i.registerHandler(e.nextElementSibling, l), n = !0);
    }), a(() => {
      n && i.unregisterHandler(r.$el.nextElementSibling);
    });
  },
  render() {
    return m(this.$slots, "default");
  }
});
export {
  x as default
};
